// @flow

import _ from 'lodash';
import { $set, update } from 'qim';

import ActionTypes from 'app/developer-v3/ActionTypes';
import { createReducer } from 'app/common/utils/ReduxUtils';

const initialState = {
  currentApp: {
    id: null,
    version: '',
  },
  modifiedAppDefinition: {},
  cleanDefinition: {},
  newCollaborator: {},
  formFields: {},
  testRequest: {
    isExecuting: false,
    output: {},
    status: '',
    errorMessage: '',
  },
  testLogs: {
    http: {
      isLoading: false,
      logs: [],
    },
    console: {
      isLoading: false,
      logs: [],
    },
    bundle: {
      isLoading: false,
      logs: [],
    },
  },
  versions: {
    lifecycle: {
      started: false,
      success: false,
      // error: false,
      errorMessage: '',
    },
  },
  hasUnsavedChanges: false,
};

const handlers = {
  [ActionTypes.SET_CURRENT_APP_ID](state, { appId }) {
    return update(['currentApp', 'id', $set(appId)], state);
  },
  [ActionTypes.SET_CURRENT_APP_VERSION](state, { appVersion }) {
    return update(['currentApp', 'version', $set(appVersion)], state);
  },
  [ActionTypes.SET_MODIFIED_APP_DEFINITION](state, { modifiedAppDefinition }) {
    return update(
      ['modifiedAppDefinition', $set(modifiedAppDefinition)],
      state
    );
  },
  [ActionTypes.SET_CLEAN_DEFINITION](state, { definition }) {
    return update(['cleanDefinition', $set(definition)], state);
  },
  [ActionTypes.GET_APP_FORM_DONE](state, { formId, fields }) {
    return update(['formFields', formId, $set(fields)], state);
  },
  [ActionTypes.GET_APP_FORM_FAIL](state, { formId }) {
    return update(['formFields', formId, $set(undefined)], state);
  },
  [ActionTypes.EXECUTE_REQUEST](state) {
    return update(['testRequest', 'isExecuting', $set(true)], state);
  },
  [ActionTypes.EXECUTE_REQUEST_DONE](
    state,
    {
      result: { output, status, errorMessage },
    }
  ) {
    const testRequest = {
      isExecuting: false,
      output,
      status,
      errorMessage,
    };

    return update(['testRequest', $set(testRequest)], state);
  },
  [ActionTypes.EXECUTE_REQUEST_FAIL](state, { error }) {
    let errorMessage = '';
    try {
      errorMessage = JSON.parse(error.responseText).errors[0];
    } catch (e) {
      // Do nothing
    }
    const testRequest = {
      ...initialState.testRequest,
      errorMessage,
      status: 'error',
    };
    return update(['testRequest', $set(testRequest)], state);
  },
  [ActionTypes.RESET_TEST_REQUEST](state) {
    return update(['testRequest', $set(initialState.testRequest)], state);
  },
  [ActionTypes.GET_TEST_LOGS](state, { logsType }) {
    return update(['testLogs', logsType, 'isLoading', $set(true)], state);
  },
  [ActionTypes.GET_TEST_LOGS_DONE](state, { events, logsType }) {
    const logs = {
      isLoading: false,
      logs: events,
    };

    return update(['testLogs', logsType, $set(logs)], state);
  },
  [ActionTypes.GET_TEST_LOGS_FAIL](state, { logsType }) {
    return update(
      ['testLogs', logsType, $set(initialState.testLogs[logsType])],
      state
    );
  },
  [ActionTypes.RESET_TEST_LOGS](state) {
    return update(['testLogs', $set(initialState.testLogs)], state);
  },
  [ActionTypes.LIFECYCLE_REQUEST](state) {
    return update(['versions', 'lifecycle', 'started', $set(true)], state);
  },
  [ActionTypes.LIFECYCLE_REQUEST_DONE](state) {
    return update(['versions', 'lifecycle', 'success', $set(true)], state);
  },
  // need to grab error value and store it in state instead of just bool
  [ActionTypes.LIFECYCLE_REQUEST_FAIL](state, { errorMessage }) {
    return update(
      ['versions', 'lifecycle', 'errorMessage', $set(errorMessage)],
      state
    );
  },
  [ActionTypes.LIFECYCLE_REQUEST_RESET](state) {
    return update(
      ['versions', 'lifecycle', $set(initialState.versions.lifecycle)],
      state
    );
  },
  [ActionTypes.SET_UNSAVED_CHANGES](state, { hasUnsavedChanges }) {
    return update(['hasUnsavedChanges', $set(hasUnsavedChanges)], state);
  },
  [ActionTypes.UPDATE_NEW_COLLABORATOR](state, { newCollaborator }) {
    const nextNewCollaborator = {
      ...state.newCollaborator,
      ...newCollaborator,
    };
    const nextState = {
      ...state,
      newCollaborator: nextNewCollaborator,
      errors: [],
    };

    if (_.isEmpty(newCollaborator)) {
      return nextState;
    }

    const nextFieldErrors = _.omitBy(
      state.fieldErrors,
      (fieldError, fieldName) => newCollaborator.hasOwnProperty(fieldName)
    );

    return { ...nextState, fieldErrors: nextFieldErrors };
  },
};

export default createReducer(handlers, initialState);
